import { Navigate } from "react-router-dom"
import { useAuth } from "../contexts/AuthProvider"

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <>
        <style>{`
          @keyframes dot1 { 0%,84%{opacity:1} 85%,100%{opacity:0} }
          @keyframes dot2 { 0%,32%{opacity:0} 33%,84%{opacity:1} 85%,100%{opacity:0} }
          @keyframes dot3 { 0%,65%{opacity:0} 66%,84%{opacity:1} 85%,100%{opacity:0} }
        `}</style>
        <div className="min-h-screen flex items-center justify-center bg-white">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full border-2 border-black/10 border-t-black animate-spin" />
            <span className="text-sm text-black/50">Setting things up</span>
            <span className="flex items-center gap-0.5">
              <span className="w-1 h-1 rounded-full bg-black/40" style={{ animation: "dot1 1.5s infinite" }} />
              <span className="w-1 h-1 rounded-full bg-black/40" style={{ animation: "dot2 1.5s infinite" }} />
              <span className="w-1 h-1 rounded-full bg-black/40" style={{ animation: "dot3 1.5s infinite" }} />
            </span>
          </div>
        </div>
      </>
    )
  }

  if (!user?.authenticated) {
    return <Navigate to="/login" replace />
  }

  // If authenticated, render the protected content
  return children
}

export default ProtectedRoute
